<template>
  <div class="custom-list-wrapper">
    <div v-show="$loading.isLoading('getContactEmails') || $loading.isLoading('getContactPhones') || $loading.isLoading('getContactAddresses')">
      <span>Loading...</span>
    </div>
    <div
      class="custom-list-header"
      v-show="!$loading.isLoading('getContactEmails') && !$loading.isLoading('getContactPhones') && !$loading.isLoading('getContactAddresses')"
    >
      <b-button
        variant="outline-secondary"
        size="sm"
        @click="newEmail"
      >Add</b-button>
      <b-button
        variant="outline-secondary"
        size="sm"
        @click="confirmDelete"
        v-show="isShowDelete"
      >Delete</b-button>
      <b-button
        variant="outline-secondary"
        size="sm"
        @click="primaryEmail"
        v-show="isShowPrimary"
      >Set as Primary</b-button>
      <span
        class="custom-title"
        v-show="showTitle"
      >Email Addresses</span>
    </div>
    <div
      class="custom-list"
      v-show="!$loading.isLoading('getContactEmails')"
    >
      <div
        v-for="item of contactEmails"
        :key="item.contactEmail"
      >
        <contact-email-record
          :recordData="item"
          @itemChecked="itemChecked"
          @editItem="editEmail"
        />
      </div>
    </div>
    <dialog-email
      v-model="actionEmail"
      :email="emailRecord"
      @closing="closeModal"
      @send="sendEmail"
    />
    <confirm-delete
      v-model="actionDelete"
      :tag="'Email(s)'"
      @closing="closeModal"
      @delete="performDelete"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import DialogEmail from '@/components/contacts/forms/email'
import ContactEmailRecord from '@/components/contacts/listings/contact-email-record'
import ConfirmDelete from '@/components/contacts/forms/confirm-delete'
export default {
  name: 'contact-emails',
  components: {
    DialogEmail,
    ContactEmailRecord,
    ConfirmDelete
  },
  props: {
    contact: {
      type: Object
    },
    showTitle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      actionEmail: null,
      actionDelete: null,
      isShowDelete: false,
      isShowPrimary: false,
      recordChecked: null,
      emailRecord: undefined
    }
  },
  computed: {
    ...mapGetters('contacts', ['contactEmails'])
  },
  methods: {
    ...mapActions('contacts', [
      'saveEmail',
      'deleteEmail',
      'setPrimaryEmail',
      'setCheckedEmail',
      'getContactEmails',
      'addEmail'
    ]),
    closeModal() {
      this.actionEmail = null
      this.actionDelete = null
      this.emailRecord = undefined
      this.recordChecked = null
    },
    itemChecked(value, checked) {
      this.isShowDelete = checked
      this.isShowPrimary = checked
      this.recordChecked = null
      if (checked) {
        this.recordChecked = value
      }
      this.setCheckedEmail({
        contactEmail: value.contactEmail,
        isChecked: checked
      })
    },
    newEmail() {
      var email = {
        firm: this.contact.firm,
        contact: this.contact.contact,
        contactEmail: -1,
        emailAddress: '',
        emailType: 0,
        emailTypeName: '',
        primary: ''
      }
      this.addEmail(email)
      this.emailRecord = email
      this.actionEmail = this.contact
    },
    editEmail(data) {
      this.emailRecord = data
      this.actionEmail = this.contact
    },
    confirmDelete() {
      this.actionDelete = true
    },
    async performDelete() {
      this.actionDelete = false
      this.isShowDelete = false
      this.isShowPrimary = false
      this.recordChecked = null
      let emails = []
      for (let email of this.contactEmails) {
        if (email.isChecked) {
          emails.push({
            contactEmail: email.contactEmail,
            contact: this.contact.contact
          })
        }
      }
      for (let email of emails) {
        await this.deleteEmail(email)
      }
      await this.getContactEmails(this.contact.contact)
    },
    async primaryEmail() {
      let data = {
        id: this.recordChecked.contactEmail,
        contact: this.contact.contact
      }
      await this.setPrimaryEmail(data)
      this.isShowDelete = false
      this.isShowPrimary = false
      this.recordChecked = null
    },
    async sendEmail(data) {
      this.actionEmail = null
      this.emailRecord = undefined
      var email = this.contactEmails.find(
        x => parseInt(x.contactEmail) === parseInt(data)
      )
      if (email !== null) {
        await this.saveEmail(email)
        await this.getContactEmails(this.contact.contact)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-list-wrapper {
  background-color: #ffffff;
  max-height: 210px;
  height: 210px;
  padding: 2px;
}
.custom-list-header {
  text-align: left;
  padding: 5px;
  border-bottom: 1px solid rgb(144, 144, 144);
  margin-bottom: 5px;
}
.custom-list {
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 5px;
  margin-left: 5px;
  margin-right: 5px;
  height: 155px;
}
.custom-title {
  float: right;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/listings/contact-emails.vue